import { useEffect, useState } from 'react';
import EmailInputPanel from '../components/GetStarted/EmailInputPanel';
import EmailEditor from '../components/Email/EmailEditor';

const Email = () => {
  const [open] = useState<boolean>(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update isMobile based on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="flex flex-row gap-4 h-[calc(100vh-100px)] overflow-hidden">
      <EmailEditor inputPanelOpen={open} />
      {open && !isMobile && <EmailInputPanel />}
    </div>
  );
};

export default Email;
